/* global Hammer */
/* global requestAnimFrame */

function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop == to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}

const sliders = document.querySelectorAll('.slider');
[].forEach.call(sliders, (slider) => {
	const left = slider.getElementsByClassName('left')[0];
  const right = slider.getElementsByClassName('right')[0];
  const nav = slider.getElementsByClassName('nav')[0];
  let slides = slider.querySelectorAll('picture, .slide');
  let x = 0;
  var mc = new Hammer(slider);
  mc.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

  right.addEventListener('click', (e) => {
    slides[x].classList.remove('active');

    x++;
    if (x == slides.length){
      x = 0;
    }
    slides[x].classList.add('active');
    // window.scrollTo(0, 0);
    if (!document.body.classList.contains('exhibition')){
      scrollTo(document.scrollingElement, 0, 100);
    }
    
    window.location.hash = x + 1;
  });
  
  left.addEventListener('click', (e) => {
    slides[x].classList.remove('active');
    
    x--;
    if (x < 0){
      x = slides.length - 1;
    }
    slides[x].classList.add('active');
    // window.scrollTo(0, 0);
    if (!document.body.classList.contains('exhibition')){
      scrollTo(document.scrollingElement, 0, 100);
    }

    window.location.hash = x + 1;
    
  });
  
  mc.on('swipeleft', () => {
    right.click();
  });
  
  mc.on('swiperight', () => {
    left.click();
  });

  [].forEach.call(slides, (s, i) => {
    s.addEventListener('click', (e) => {
      slides[x].classList.remove('active');
      x = i;
      slider.classList.toggle('showall');
      slides[x].classList.add('active'); 
      // Scroll to top
      window.scrollTo(0, 0);
    })
  });

  const init = () => {

    slides = slider.querySelectorAll('picture, .slide');
    console.log(slides);

    if (slides.length == 0){
      nav.style.display = 'none';
    } else {
      nav.removeAttribute('style');
    }

    // force all slider images to load
    [].forEach.call(slider.getElementsByTagName('picture'), (p) => {
      if (p.getElementsByTagName('img').length){
        if (p.getElementsByTagName('img')[0].classList.contains('loaded'))
          return; 

        if (p.getElementsByTagName('img')[0].classList.contains('lazy')){
          [].forEach.call(p.getElementsByTagName('source'), (s) => {
            s.setAttribute('srcset', s.getAttribute('data-srcset'))
          });
          p.getElementsByTagName('img')[0].setAttribute('src', p.getElementsByTagName('img')[0].getAttribute('data-src'));
          p.getElementsByTagName('img')[0].classList.add('loaded');
          p.getElementsByTagName('img')[0].classList.remove('loading');
        }
      }
    });

    if (window.location.hash && !slider.classList.contains('flipbook')) {
      if (parseInt(window.location.hash.replace("#",""))) {
        let y = parseInt(window.location.hash.replace("#",""));
        if (y < slides.length) {
          x = y - 1;
          slider.querySelector('.active').classList.remove('active');
          slides[x].classList.add('active');
        }
        
      }
    }
  };

  init();

  const update = () => {
  
    init();
  };

  document.body.addEventListener('update', update, false);
});



const gallery = document.querySelectorAll('.allimages');
[].forEach.call(gallery, (g) => {
  g.addEventListener('click', (e) => {
    e.preventDefault();

    [].forEach.call(sliders, (slider) => {
      if (slider.classList.contains('archive'))
        return;

      
      slider.classList.toggle('showall');
      document.body.classList.toggle('showall');
      if (document.body.classList.contains('info-active')){
        document.body.classList.remove('info-active');
        document.getElementsByClassName('information')[0].classList.remove('active')
      }
      
    })
  });
});